import React, { useState, useRef, useEffect } from "react";
import "../TitledCheckedDropDown/TitledCheckedDropDown.css";
import { Globals as OldGlobals } from "../../global/Globals";
import { useLanguage } from "../../context/Languagecontext";

const TitledEditDropdown = ({
    title,
    options,
    onSelectAll,
    onSelect,
    selectedValues,
    selectClass,
    extraStyle,
}) => {
    const dropdownRef = useRef(null);
    const [selectedOptions, setSelectedOptions] = useState(selectedValues || []);
    const [isOpen, setIsOpen] = useState(false);
    const { Globals } = useLanguage();

    const isAllSelected = options?.length > 0 && options?.every(opt => selectedOptions.some(sel => sel.id === opt.id));

    useEffect(() => {
        setSelectedOptions(selectedValues || []);
    }, [selectedValues]);
console.log("selectedValues",selectedValues)
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const collapseDropdown = () => {
        setIsOpen(false);
    };

    const handleSelectedItems = (option) => {
        const newSelectedOptions = selectedOptions.some(sel => sel.id === option.id)
            ? selectedOptions.filter(sel => sel.id !== option.id)
            : [...selectedOptions, option];

        setSelectedOptions(newSelectedOptions);
        onSelect(newSelectedOptions); // Update onSelect with the new selectedOptions
    };

    const handleSelectAllItems = (e) => {
        const newSelectedOptions = e.target.checked ? options : [];

        setSelectedOptions(newSelectedOptions);
        onSelect(newSelectedOptions); //update onSelect with the new selectedOptions
        onSelectAll(e.target.checked);
    };

    const getDisplayText = () => {
        if (selectedOptions?.length === 0) {
            return title;
        } else if (selectedOptions?.length <= 2) {
            return selectedOptions.map(opt => opt.name).join(', ');
        } else {
            return `${selectedOptions[0].name}, ${selectedOptions[1].name} + ${selectedOptions.length - 2}`;
        }
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };
    useEffect(() => {
        console.log("selectedValues changed:", selectedValues);
        setSelectedOptions(selectedValues || []);
        console.log("selectedOptions updated:", selectedOptions);
    }, [selectedValues]);
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    console.log("Options:", options, "Selected Options:", selectedOptions);

    return (
        <div className={"titledCheckedDropdown " + selectClass || ""} ref={dropdownRef}>
            <div className="titledCheckedDropdown-title" onClick={toggleDropdown} onBlurCapture={collapseDropdown}>
                <div className={`title ${selectedOptions && selectedOptions.length > 0 ? "selected-items" : ""}`}>{getDisplayText()}</div>
                <div className="titledCheckedDropdown-img">
                    <img className="titledCheckedDropdown-img" src={Globals.IMG.DROPDOWN} alt="titledCheckedDropdown" />
                </div>
            </div>
            {isOpen && (
                <div className="titledCheckedDropdown-content">
                    <div key={"Select-All"} id="selectall" className="titledCheckedDropdown-Item selectALL">
                        <input
                            type="checkbox"
                            id=""
                            value="SelectAll"
                            className="filter_checkbox"
                            checked={isAllSelected}
                            onChange={handleSelectAllItems}
                        />
                        <label htmlFor="selectall" id="select-all-items" className="option-label-list">
                            {Globals.CHECKDROPDOWN.SELECTALL}
                        </label>
                    </div>
                    {options && options.map((option) => (
                        <div key={option.id} className="titledCheckedDropdown-Item">
                            <input
                                type="checkbox"
                                id={option.id}
                                value={option.name}
                                className="filter_checkbox"
                                checked={selectedOptions.some(sel => sel.id === option.id)}
                                onChange={() => handleSelectedItems(option)}
                            />
                            <label htmlFor={option.name} className="option-label-titled">
                                {option.name}
                            </label>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TitledEditDropdown;